export function resolveProfilePhotoUrl(profile, authUser) {
  if (profile?.perfilUsuario?.fotoPerfil) {
    return profile.perfilUsuario.fotoPerfil;
  }

  if (authUser?.perfilUsuario?.fotoPerfil) {
    return authUser.perfilUsuario.fotoPerfil;
  }

  return null;
}
